/*
  Surgismart Custom JS
*/

// 1. ROLLING 3-HOUR COUNTDOWN
(function () {
  var DURATION = 3 * 60 * 60 * 1000;
  var STORAGE_KEY = 'surgismart_countdown_end';

  function getDeadline() {
    var stored = localStorage.getItem(STORAGE_KEY);
    var now = Date.now();
    if (stored) {
      var end = parseInt(stored, 10);
      if (end > now) return end;
    }
    var newEnd = now + DURATION;
    localStorage.setItem(STORAGE_KEY, newEnd);
    return newEnd;
  }

  function patchCountdown() {
    if (!customElements.get('countdown-component')) { setTimeout(patchCountdown, 50); return; }
    document.querySelectorAll('countdown-component[data-countdown]').forEach(patchEl);
    new MutationObserver(function(m) {
      m.forEach(function(mu) {
        mu.addedNodes.forEach(function(n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('countdown-component[data-countdown]')) patchEl(n);
          if (n.querySelectorAll) n.querySelectorAll('countdown-component[data-countdown]').forEach(patchEl);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function patchEl(el) {
    if (el._patched) return;
    el._patched = true;
    var deadline = getDeadline();
    el.dataset.countdown = deadline;
    if (el.myInterval) clearInterval(el.myInterval);
    el.myInterval = setInterval(function() {
      var diff = deadline - Date.now();
      if (diff <= 0) {
        clearInterval(el.myInterval);
        localStorage.setItem(STORAGE_KEY, Date.now() + DURATION);
        el._patched = false;
        patchEl(el);
        return;
      }
      tick(el, diff);
    }, 1000);
    tick(el, deadline - Date.now());
  }

  function tick(el, diff) {
    if (diff < 0) diff = 0;
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var he = el.querySelector('[data-countdown-hours]');
    var me = el.querySelector('[data-countdown-minutes]');
    var se = el.querySelector('[data-countdown-seconds]');
    var de = el.querySelector('[data-countdown-days]');
    if (de && de.parentElement) de.parentElement.style.display = 'none';
    if (he && he.parentElement) { he.parentElement.style.display = ''; he.textContent = String(h).padStart(2,'0'); }
    if (me) me.textContent = String(m).padStart(2,'0');
    if (se) se.textContent = String(s).padStart(2,'0');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchCountdown);
  } else {
    patchCountdown();
  }
})();

// 2. SALES NOTIFICATION POPUP
(function () {
  var ORDERS = [
    { name: 'Priya', city: 'Chennai', product: 'Classic New Gen Scrub Suit', time: '2 minutes ago', handle: 'classic-new-gen-scrubsuit' },
    { name: 'Anitha', city: 'Coimbatore', product: 'Classic New Gen Scrub Suit', time: '8 minutes ago', handle: 'classic-new-gen-scrubsuit' },
    { name: 'Divya', city: 'Bengaluru', product: 'Classic New Gen Scrub Suit', time: '14 minutes ago', handle: 'classic-new-gen-scrubsuit' },
    { name: 'Meena', city: 'Hyderabad', product: 'Classic New Gen Scrub Suit', time: '23 minutes ago', handle: 'classic-new-gen-scrubsuit' },
    { name: 'Lakshmi', city: 'Madurai', product: 'Classic New Gen Scrub Suit', time: '31 minutes ago', handle: 'classic-new-gen-scrubsuit' },
    { name: 'Kavitha', city: 'Pune', product: 'Classic New Gen Scrub Suit', time: '45 minutes ago', handle: 'classic-new-gen-scrubsuit' },
    { name: 'Shalini', city: 'Mumbai', product: 'Classic New Gen Scrub Suit', time: '52 minutes ago', handle: 'classic-new-gen-scrubsuit' },
    { name: 'Revathi', city: 'Trichy', product: 'Classic New Gen Scrub Suit', time: '1 hour ago', handle: 'classic-new-gen-scrubsuit' },
    { name: 'Nivetha', city: 'Delhi', product: 'Classic New Gen Scrub Suit', time: '1 hour ago', handle: 'classic-new-gen-scrubsuit' },
    { name: 'Sunita', city: 'Tirunelveli', product: 'Classic New Gen Scrub Suit', time: '2 hours ago', handle: 'classic-new-gen-scrubsuit' },
    { name: 'Ramesh', city: 'Chennai', product: 'Classic New Gen Scrub Suit', time: '3 minutes ago', handle: 'classic-new-gen-scrubsuit' },
    { name: 'Arun', city: 'Vellore', product: 'Classic New Gen Scrub Suit', time: '19 minutes ago', handle: 'classic-new-gen-scrubsuit' },
    { name: 'Karthik', city: 'Salem', product: 'Classic New Gen Scrub Suit', time: '37 minutes ago', handle: 'classic-new-gen-scrubsuit' },
    { name: 'Vijay', city: 'Erode', product: 'Classic New Gen Scrub Suit', time: '58 minutes ago', handle: 'classic-new-gen-scrubsuit' },
    { name: 'Suresh', city: 'Kolkata', product: 'Classic New Gen Scrub Suit', time: '1 hour ago', handle: 'classic-new-gen-scrubsuit' }
  ];

  var IMG_URL = 'https://cdn.shopify.com/s/files/1/0922/2953/3976/files/1_18d024c3-bc74-446f-ba71-d6c0b025a4fd.jpg?v=1771348175';
  var SHOW_DELAY = 5000;
  var HIDE_AFTER = 6000;
  var BETWEEN = 18000;
  var shown = [];
  var popup, hideTimer;

  function buildPopup() {
    popup = document.createElement('div');
    popup.id = 'ss-salespop';
    popup.setAttribute('role', 'status');
    popup.innerHTML =
      '<button id="ss-salespop-close" aria-label="Close">&times;<\/button>' +
      '<a id="ss-salespop-link" href="/products/classic-new-gen-scrubsuit" style="display:flex;align-items:center;gap:12px;text-decoration:none;flex:1;min-width:0;">' +
        '<img id="ss-salespop-img" src="" alt="Scrub Suit" style="width:52px;height:52px;border-radius:50%;object-fit:cover;flex-shrink:0;">' +
        '<div id="ss-salespop-body" style="flex:1;min-width:0;">' +
          '<p id="ss-salespop-name"><\/p>' +
          '<p id="ss-salespop-product"><\/p>' +
          '<p id="ss-salespop-time"><\/p>' +
        '<\/div>' +
      '<\/a>' +
      '<div id="ss-salespop-dot"><\/div>';
    document.body.appendChild(popup);
    document.getElementById('ss-salespop-close').addEventListener('click', function (e) {
      e.stopPropagation();
      hide();
    });
  }

  function getNext() {
    if (shown.length >= ORDERS.length) shown = [];
    var remaining = [];
    for (var i = 0; i < ORDERS.length; i++) {
      if (shown.indexOf(i) === -1) remaining.push(i);
    }
    var pick = remaining[Math.floor(Math.random() * remaining.length)];
    shown.push(pick);
    return ORDERS[pick];
  }

  function show(order) {
    var link = document.getElementById('ss-salespop-link');
    link.href = '/products/' + order.handle;
    document.getElementById('ss-salespop-img').src = IMG_URL;
    document.getElementById('ss-salespop-name').textContent = order.name + ' from ' + order.city + ' purchased';
    document.getElementById('ss-salespop-product').textContent = order.product;
    document.getElementById('ss-salespop-time').textContent = order.time;
    popup.classList.add('ss-visible');
  }

  function hide() {
    popup.classList.remove('ss-visible');
  }

  function cycle() {
    show(getNext());
    hideTimer = setTimeout(function () {
      hide();
      setTimeout(cycle, BETWEEN);
    }, HIDE_AFTER);
  }

  function init() {
    buildPopup();
    setTimeout(cycle, SHOW_DELAY);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
